"use strict";

const $ = jQuery;
// const LumerisModal = require('../../../../../../../../../src/javacripts/components/lumeris-modal.js');
const LumerisModal = require('./lumeris-modal.js');

module.exports = class {
	#$module;
    #$form;
    #$zipCodeInput;
    #$planYearInput;
    #$submitButton;
    #$loadingAnimation;
    #$errorModal;
    #$errorMessageContainer;

	#data = {};
    #baseUrl = '/wp-json/lumeris';
	#initialized = false;
    #errorModal;
    

	constructor($module, data) {
        this.#data = data;
		this.#$module = $module;
        this.#$form = $module.find('form');
        this.#$zipCodeInput = $module.find('input.zip-code');
        this.#$planYearInput = $module.find('input.plan-year');
        this.#$submitButton = $module.find('button');
        this.#$loadingAnimation = $module.find('.loading-animation');

		this.build();

        this.#errorModal = new LumerisModal({
            id: this.id  + '-error-modal',
            modalClass: 'lum-zc2market-formulary-search-router-error-modal',
            //header: '',
            cancelButton: true,
			destroyOnCancel: false
        });
        
        this.#$errorModal = $(this.#errorModal);
		this.#$errorMessageContainer = $('<div class="error-message-container"></div>');

		this.errorModal.prependBodyContent(this.#$errorMessageContainer);

		this.bind();

		this.#initialized = true;
	}

	bind() {
        this.$zipCodeInput.on('keyup', (event) => { this.onZipCodeInputKeyUp(event); });
		this.$submitButton.on('click', (event) => { this.onSubmitButtonClick(event); });
		
		this.errorModal.on('lumeris-modal:cancelButtonClick', (event) => { this.onCancelButtonClick(event); });
	}

    build() {
        
    }

    get $module() {
        return this.#$module;
    }

    get $form() {
        return this.#$form;
    }

    get $zipCodeInput() {
        return this.#$zipCodeInput;
    }

    get $planYearInput() {
        return this.#$planYearInput;
    }

    get $submitButton() {
        return this.#$submitButton;
    }

    get $loadingAnimation() {
        return this.#$loadingAnimation;
    }

    get $errorModal() {
        return this.#$errorModal;
    }

    get $errorMessageContainer() {
        return this.#$errorMessageContainer;
    }

    get initialized() {
		return this.#initialized;
	}

    get baseUrl() {
        return this.#baseUrl;
    } 

    get data() {
        return this.#data;
    }

    get id() {
        return this.data.node;
    }

    get errorModal() {
        return this.#errorModal;
    }

    async getRoute(options={}) {
		const json = await fetch(`${this.baseUrl}/v1/get-formulary-search-market-route/?${this.generateQueryString(options)}`, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			cache: 'no-cache'
		}).then((response) => {
			return response.json();
		}).catch((error) => {
			console.error(error);
			return [];
		});

        return json;
	}

    showErrorModal() {
        this.errorModal.trigger('lumeris-modal:show');
	}

    showLoading() {
		this.$module.addClass('is-loading');
	}

	hideErrorModal() {
		this.errorModal.trigger('lumeris-modal:hide');
	}

    hideLoading() {
        this.$module.removeClass('is-loading');
    }

    clear() {
		this.hideErrorModal();
        this.hideLoading();
		this.reset();
	}

	reset() {
		this.$zipCodeInput.val('');
		this.$errorMessageContainer.html('');
	}

    filterZipCode(zipCode) {
        return zipCode.replace(/\D/g, '').slice(0, 5) || '';
    }

    generateQueryString(params={}) {
        const keys = Object.keys(params);

        if (keys.length === 0) {
            return '';
        }

        return Object.keys(params).map((key) => {
            return (params[key] == null || typeof params[key] === 'string' || typeof params[key] === 'boolean') ? key + '=' + encodeURIComponent(params[key]) : key + '=' + encodeURIComponent(params[key].join(','));
        }).join('&');
    }

    onZipCodeInputKeyUp(event) {
		if (!(event.originalEvent instanceof Event)) {
			return null;
		}

		this.$zipCodeInput.val(this.filterZipCode(this.$zipCodeInput.val()));
	}

	async onSubmitButtonClick(event) {
		if (!(event.originalEvent instanceof Event) && !(event.originalEvent instanceof PointerEvent) && !(event.originalEvent instanceof MouseEvent)) {
			return null;
		}

		event.preventDefault();

		this.showLoading();

		const route = await this.getRoute({
			zip_code: this.$zipCodeInput.val(),
            plan_year: this.$planYearInput.val()
		});

		if (typeof route.error_message !== 'undefined') {
			this.$errorMessageContainer.html(route.error_message);
            this.hideLoading();
			this.showErrorModal();
			return null;
		}

		if (typeof route.permalink !== 'undefined') {
			this.$form.attr('action', route.permalink);
			this.$form.get(0).submit();
			return true;
		}
	}

    onCancelButtonClick(event) {
		if (event instanceof Object === false) {
			return null;
		}

		this.reset();
	}
}